import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import { User } from '../../models/user';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  user: User;
  errorMessage: any;

  constructor(private userService:UserService) { }

  ngOnInit() {
    console.log('Getting user');
    this.userService.GetUser()
                .subscribe(u => {
                    this.onSubscribe(u)
                }, error => this.errorMessage = <any>error);
  }

  onSubscribe(acc: any) {
    console.log(acc);
    
    this.user = acc.ApprovedBy;
    console.log(this.user);
    
}

}



// WEBPACK FOOTER //
// ./src/app/components/user/user.component.ts